import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  notEnrolledContainer: {
    height: '100%',
    display: 'flex',
    alignItems: 'center'
  },
  notEnrolledContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  textWrap: {
    textAlign: 'center'
  },
  semiBoldText: {
    fontWeight: '500',
    fontSize: 20,
    marginBottom: '1rem'
  },
  normalText: {
    marginTop: '4rem',
    fontSize: 16,
  },
  normalBoldText: {
    fontWeight: '500',
    fontSize: 16,
  },
  notEnrolledBtnWrap: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& .MuiCircularProgress-root': {
      color: '#fff'
    }
  },
  notEnrolledBtn: {
    width: '14.5rem',
    paddingLeft: 10,
    paddingRight: 10,
  },
  proceedBtn: {
    margin: '4rem 0 1rem 0',
  },
  tryAgainBtn: {
    marginBottom: '1rem',
  },
}));
